export const MAX_IMAGE_SIZE_MB = 20;

export const IMAGE_VALIDATION_MESSAGES = {
  not_image: "画像以外のファイルはアップロードできません",
  invalid_format: "jpg/png以外の画像はアップロードできません",
  exceeds_size: `アップロードに失敗しました。\nファイルサイズを${MAX_IMAGE_SIZE_MB}MB以下にしてください。`,
};
